import React, {useState, useEffect} from 'react';
import {createPortal} from 'react-dom';

const IFrame = ({
  children,
  iFrameRef,
  onLoad,
  ...props
}) => {
  const [contentRef, setContentRef] = useState(null);

  const mountNode = contentRef?.contentWindow?.document?.body;

  // setting content security policy for iframe
  const meta = document?.createElement('meta');
  meta.httpEquiv = 'Content-Security-Policy';
  // eslint-disable-next-line
  meta.content= "default-src 'self'; object-src 'none'; font-src 'self' data:; img-src 'self' https://*.zoom.us https://*.zoomdev.us https://zoom.us data: zmdf:; media-src 'self' https://*.zoom.us https://*.zoomdev.us https://zoom.us data: zmdf:; style-src 'self' 'unsafe-eval' 'unsafe-inline'; script-src 'none'; child-src 'self' mailto: tel: callto: zoomphonecall: zoomus: data: zmdf:"

  // setting css for iframe
  const css = document.createElement('style');
  css.appendChild(document.createTextNode(props.innerhtmlstyles));

  useEffect(() => {
    contentRef?.contentWindow?.document?.head.append(meta);
    contentRef?.contentWindow?.document?.head.append(css);
    if (contentRef?.contentWindow?.document?.body) {
      if (iFrameRef && !iFrameRef.current) {
        iFrameRef.current = contentRef;
        onLoad && onLoad();
      }
    }
  }, [contentRef, css, meta, onLoad, iFrameRef]);

  return (
    <iframe
      title="myFrame"
      id="myFrame"
      ref={setContentRef}
      style={props.iframestyles}
      sandbox="allow-same-origin"
      {...props}
    >
      {mountNode && createPortal(children, mountNode)}
    </iframe>
  );
};

export default IFrame;
